import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panne-declarer-add',
  templateUrl: './panne-declarer-add.component.html',
  styleUrls: ['./panne-declarer-add.component.scss']
})
export class PanneDeclarerAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
